import { render } from "./GoalsList.vue?vue&type=template&id=75eb6b30&scoped=true"
import script from "./GoalsList.vue?vue&type=script&lang=js"
export * from "./GoalsList.vue?vue&type=script&lang=js"

import "./GoalsList.vue?vue&type=style&index=0&id=75eb6b30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75eb6b30"]])

export default __exports__